import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { GraphQLDataTable, Column, Button } from '@spoiler-alert/ui-library';
import { AdminSitesQuery } from '../../graphql/queries';
import TransactionCycle from './transaction-cycle';
import routePaths from '../../route-paths';

const styles = {
  confirm_buttons: {
    display: 'flex',
    marginTop: 10,
  },
  distribution_button: {
    display: 'flex',
    marginTop: 5,
    marginRight: 10,
  },
  button_wrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  wrapSellerSites: {
    padding: 15,
  },
};

@injectSheet(styles)
export default class SellerSites extends Component {
  static propTypes = {
    user: PropTypes.object,
    classes: PropTypes.object,
    history: PropTypes.object,
  };

  handleDynamicRowClick = (row) => {
    this.props.history.push(`/distribution-lists/${row._id}`);
  };

  handleFacilityListClick = (row) => {
    this.props.history.push(`${routePaths.sites}/${row._id}`);
  };

  handleSiteDetailsClick = (row) => {
    this.props.history.push(`${routePaths.sites}/${row._id}/${row._id}`);
  };

  buttonRow = (row) => {
    const { classes } = this.props;
    const rowValues = [
      <Button
        key="facility-list"
        onClick={this.handleFacilityListClick.bind(this, row)}
        className={classes.distribution_button}
      >
        Facility List
      </Button>,
      <Button
        key="site-details"
        onClick={this.handleSiteDetailsClick.bind(this, row)}
        className={classes.distribution_button}
      >
        Site Details
      </Button>,
    ];
    if (row.siteType === 'ORGANIZATION' || row.siteType === 'BUSINESS_UNIT') {
      rowValues.push(
        <Button key="dls" onClick={this.handleDynamicRowClick.bind(this, row)} className={classes.distribution_button}>
          Distribution Lists
        </Button>,
      );
    }
    if (row.siteType === 'ORGANIZATION') {
      rowValues.push(<TransactionCycle site={row} />);
    }
    return <div className={classes.button_wrapper}>{rowValues}</div>;
  };

  columns = [
    new Column({ field: 'siteName', displayName: 'Site Name', sortable: true, defaultSort: true }),
    new Column({
      field: 'transactionCycle',
      displayName: 'Site Actions',
      formatter: (value, row) => this.buttonRow(row),
    }),
  ];

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapSellerSites}>
        <GraphQLDataTable
          search
          query={AdminSitesQuery}
          queryName="adminUserQuery"
          transition
          queryField="customerSites"
          columns={this.columns}
        />
      </div>
    );
  }
}
